/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface UpdateLoyaltyProgram$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
      body: Program
}

export function updateLoyaltyProgram(http: HttpClient, rootUrl: string, params: UpdateLoyaltyProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Program>> {
  const rb = new RequestBuilder(rootUrl, updateLoyaltyProgram.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Program>;
    })
  );
}

updateLoyaltyProgram.PATH = '/loyalty/programs/{programId}';
